import styled from 'styled-components';

export const AuthContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const AuthContainerWrapper = styled.div`
  width: 500px;
`;
